<!-- main-navbar.component.html -->
<header class="header">
  <div class="top-container">

    <!-- Top bar: logo + language + user + search -->
    <div class="top-bar">
      <div class="logo-area">
        <img
          src="assets/gafiLogo.png"
          alt="GAFI Logo"
          class="logo"
        />
      </div>

      <div class="top-right-group">
        <!-- Language -->
        <a href="#" class="lang-switcher">EN</a>

        <!-- Not logged in -->
        <ng-container *ngIf="!isAuthenticated">
          <a href="/auth/login" class="auth-link">تسجيل الدخول</a>
          <a href="/auth/register" class="auth-link">مستخدم جديد</a>
        </ng-container>

        <!-- Logged in -->
        <ng-container *ngIf="isAuthenticated">
          <div class="user-dropdown-wrapper hover-dropdown">
            <button class="user-toggle" type="button">
              <span class="welcome-txt">مرحبا، {{ getFullName() }}</span>
              <i class="fa-solid fa-chevron-down dropdown-arrow"></i>
            </button>

            <div class="dropdown-menu user-dropdown">
              <a class="dropdown-item" routerLink="/workspace/profile">تعديل البيانات الشخصية</a>
              <a class="dropdown-item" href="/workspace">مساحة العمل</a>
              <a class="dropdown-item" *ngIf="canViewFreeZones" (click)="goToFreeZones()" target="_blank">خدمات المناطق الحرة</a>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item logout-btn" (click)="logout()">تسجيل الخروج</button>
            </div>
          </div>
        </ng-container>

        <!-- Search -->
        <button type="button" class="search-btn">
          <i class="fa-solid fa-magnifying-glass"></i>
        </button>

        <!-- Mobile menu button -->
        <button
          class="mobile-toggle"
          aria-label="فتح/إغلاق القائمة"
          (click)="mobileMenuOpen = !mobileMenuOpen"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <!-- Main Navigation -->
    <nav class="main-nav" [class.open]="mobileMenuOpen">
      <ul class="main-menu">
        <li class="menu-item dropdown hover-dropdown">

          <a class="menu-link" routerLink="/mainwhyEgypt">
            لماذا مصر ؟
            <span class="dropdown-indicator">▼</span>
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLink="/whyEgypt">عن مصر</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/indicators">أهم المؤشرات الاقتصادية</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/success">قصص النجاح</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/develpment">بنية حديثة و مطورة</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/youth">الشباب والابتكار</a>
          </div>
        </li>

        <li class="menu-item">
          <a class="menu-link" href="#">الخريطة الاستثمارية</a>
        </li>

        <li class="menu-item dropdown hover-dropdown">
          <a class="menu-link" routerLink="/goahead">
            انطلق
            <span class="dropdown-indicator">▼</span>
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLink="/investment-systems">الأنظمة الاستثمارية</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/business-rules">الحقائق التجارية</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/regulations-and-rules">القوانين واللوائح</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/suggested-sites">مواقع مقترحة</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/investor-guide">دليل المستثمر</a>
          </div>
        </li>

        <li class="menu-item dropdown hover-dropdown">
          <a class="menu-link" routerLink="/investmentSectors">
            قطاعات الإستثمار
            <span class="dropdown-indicator">▼</span>
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLink="/economicPerformance">القطاعات المستهدفة</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/agreements">الإتفاقيات التجارية</a>
          </div>
        </li>

        <li class="menu-item dropdown hover-dropdown">
          <a class="menu-link" routerLink="/help">
            كيف يمكننا أن نساعد
            <span class="dropdown-indicator">▼</span>
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLink="/InvestorsCenterComponent">مركز خدمات المستثمرين</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/InvestorsAgentsComponent">مركز شئون وكلاء المستثمرين</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/InvestorsDisputeComponent">مركز تسوية منازعات المستثمرين</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/FrequentlyAskedQuestionsComponent">الأسئلة الشائعة</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/SocialResponsibilityComponent">المسئولية المجتمعية للشركات</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/CareEgyptianInvestorsComponent">وحدة رعاية المستثمرين المصريين بالخارج</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/EconomicperformanceHelpComponent">الأداء الاقتصادي</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/EgyptianCitizenshipComponent">منح الجنسية مقابل الاستثمار</a>
          </div>
        </li>

        <li class="menu-item dropdown hover-dropdown">
          <a class="menu-link" routerLink="/mediacenter">
            المركز الإعلامي
            <span class="dropdown-indicator">▼</span>
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLink="/medianews">الأخبار</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/mediaActions">الأحداث</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/mediaVideos">معرض الفيديو</a>
          </div>
        </li>

        <li class="menu-item dropdown hover-dropdown">
          <a class="menu-link">
            الخدمات الإلكترونية
            <span class="dropdown-indicator">▼</span>
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLink="/allServices">جميع الخدمات</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="/services/premission">صلاحية التعامل على الشركات</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item"  (click)="goToEServices()">التأسيس الإلكتروني</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/investmentReport">تقارير الاستثمار الأجنبي المباشر</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item"(click)="goToFreeZones()" target="_blank">خدمات المناطق الحرة</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/compliments">الشكاوى</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/goldenPermission">الرخصة الذهبية</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/evaluation">تقييم خدمات الهيئة</a>
          </div>
        </li>
      </ul>
    </nav>

  </div>
</header>
